import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const VERSIONS_URL = 'https://static.soulmachines.com/widget-versions.json';
@Injectable()
export class WidgetSnippetService {
  constructor(private http: HttpClient) {}

  loadVersions(): Observable<string[]> {
    return this.http.get<{ versions: string[] }>(VERSIONS_URL).pipe(map((data) => data.versions));
  }
}
